import React, { useState } from 'react';
import { useLocation, Navigate } from 'react-router';

import { IAuthContext, StartSessionResponse } from '../../types/auth';
import { closeSession, failure, startSession } from '../../types/api';

import apiFunctions from '../../api';

export const useAuth = () => {
  return React.useContext(AuthContext);
};

export const AuthContext = React.createContext<IAuthContext>({
  user: undefined,
  sessionToken: undefined,
  login: () => Promise.resolve(),
  logout: () => {},
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<string | undefined>(sessionStorage.getItem('User') ?? undefined);
  const [sessionToken, setSessionToken] = useState<string | undefined>(
    sessionStorage.getItem('SessionToken') ?? undefined,
  );

  const login = async (code: string) => {
    return await apiFunctions.apiPost(startSession, { linkCode: code }).then((res: StartSessionResponse) => {
      let response = res;
      if (response.userEmail == null || response.sessionToken == null) {
        return failure;
      } else {
        setSessionToken(response.sessionToken);
        sessionStorage.setItem('SessionToken', response.sessionToken);

        setUser(response.userEmail);
        sessionStorage.setItem('User', response.userEmail);

        return response;
      }
    });
  };

  const logout = async (callback: VoidFunction) => {
    await apiFunctions.apiPost(closeSession).then(() => {
      setUser(undefined);
      setSessionToken(undefined);
      sessionStorage.removeItem('SessionToken');
      sessionStorage.removeItem('User');
      callback();
    });
  };

  let value = { user, sessionToken, login, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const Authorized = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) return <Navigate to="/login" state={{ from: location }}></Navigate>;
  else return <>{children}</>;
};
